import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAccommodationRoomType($companyId: ID!, $attributes: AccommodationRoomTypeAttributes!) {
    createAccommodationRoomType(companyId: $companyId, attributes: $attributes) {
      accommodationRoomType {
        id
        ...CreatedAccommodationRoomType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAccommodationRoomType on AccommodationRoomType {
    id
    name
    layout
    capacity
    notes
  }
`
